import dayjs from "dayjs";
import "dayjs/locale/ja";

dayjs.locale("ja");

window.onload = () => {
  const today = dayjs();
  const year = today.year();

  const target = dayjs(`${year}-11-11`);
  const day = target.format("YYYY/MM/DD");
  document.getElementById("day").innerText = day;
  document.getElementById("datetext").innerText = target.format("(ddd)");
};
